var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckBlueMayca(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152,
    height: 144,
    viewBox: "0 0 152 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3749",
    "data-name": "Group 3749",
    transform: "translate(-120 -48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2845",
    "data-name": "Rectangle 2845",
    d: "M24,0H84a68,68,0,0,1,68,68v8a68,68,0,0,1-68,68H68A68,68,0,0,1,0,76V24A24,24,0,0,1,24,0Z",
    transform: "translate(120 48)",
    fill: "#542eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "check_circle_24dp_434343_FILL1_wght400_GRAD0_opsz24",
    d: "M109.619-839.36l-7.4-7.4a3.266,3.266,0,0,0-2.411-.947,3.266,3.266,0,0,0-2.411.947,3.266,3.266,0,0,0-.947,2.411,3.266,3.266,0,0,0,.947,2.411l9.816,9.816a3.3,3.3,0,0,0,2.411,1.033,3.3,3.3,0,0,0,2.411-1.033l19.459-19.459a3.266,3.266,0,0,0,.947-2.411,3.266,3.266,0,0,0-.947-2.411,3.266,3.266,0,0,0-2.411-.947,3.266,3.266,0,0,0-2.411.947Zm4.822,28.242a33.537,33.537,0,0,1-13.432-2.712,34.781,34.781,0,0,1-10.935-7.362,34.78,34.78,0,0,1-7.362-10.935A33.537,33.537,0,0,1,80-845.559a33.537,33.537,0,0,1,2.712-13.432,34.78,34.78,0,0,1,7.362-10.935,34.781,34.781,0,0,1,10.935-7.362A33.537,33.537,0,0,1,114.441-880a33.537,33.537,0,0,1,13.432,2.712,34.781,34.781,0,0,1,10.935,7.362,34.78,34.78,0,0,1,7.362,10.935,33.537,33.537,0,0,1,2.712,13.432,33.537,33.537,0,0,1-2.712,13.432,34.78,34.78,0,0,1-7.362,10.935,34.781,34.781,0,0,1-10.935,7.362A33.537,33.537,0,0,1,114.441-811.118Z",
    transform: "translate(81.56 965.559)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBlueMayca);
export default __webpack_public_path__ + "static/media/check_blue_mayca.e8d4b264c8be57e06e0addb041c5381c.svg";
export { ForwardRef as ReactComponent };